<script lang="ts">var _a, _b, _c, _d, _e, _f;
import CardBase from '../../../common/CardBase.svelte';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import { Readable } from 'svelte/store';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import ROOT from '../../../../../inversify.config';
import TextInput from "../TextInput/TextInput.svelte";
import { t } from "../../../../../js/i18n";
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: enableConfirm = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.enableConfirm) || false;
$: enableValidate = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.enableValidate) || false;
$: isRequiredKey = (_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.isRequiredKey;
$: key = (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.key;
$: isRequired = isRequiredKey ? ($mergedParams || {})[isRequiredKey] : '';
$: validKey = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.validKey) || 'isValidPhone';
$: valid = enableValidate && validKey ? ($mergedParams || {})[validKey] : 'true';
//let mask = "000-0000-0000";
//mask={mask} maskChar={'X'} 
let phoneNumber = '';
const handleChange = (e) => {
    //phoneNumber = e.detail.inputState.maskedValue;
    phoneNumber = e.target.value;
    console.log('phoneNumber: ', phoneNumber);
    tabContext.setParam(key, phoneNumber);
    tabContext.setParam(validKey, valid + "");
};
$: placeholder = $t("Phone Number") + (isRequired === 'true' ? "*" : "");
</script>

<CardBase {element}>
    <div class="phonenumber-input-field-wrapper">
        <TextInput type="number" placeholder={placeholder} value={phoneNumber} onChange={handleChange} pattern={'\\d*'} />
    </div>
</CardBase>

<style>.phonenumber-input-field-wrapper {
  gap: 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
}</style>
